import { createTheme } from '@mui/material';
import type { ThemeParamsType } from '@tma.js/sdk';

const DEFAULT_PRIMARY = '#2481cc';
const DEFAULT_SECONDARY = '#708499';

export const createMuiTheme = (tp?: ThemeParamsType) => {
    const primary = tp?.button_color ?? DEFAULT_PRIMARY;
    const secondary = tp?.hint_color ?? DEFAULT_SECONDARY;

    return createTheme({
        palette: {
            primary: {
                main: primary,
            },
            secondary: {
                main: secondary,
            },
        },
    });
};
